module.exports = __webpack_public_path__ + "static/media/1.05598af5.jpeg";